import { ApolloClient, ApolloLink, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from "apollo-upload-client";
import config from "../config";
import { getAccessToken, isTokenExpired } from "../utils/token";
import { handleAuthError } from "../components/auth";

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) => console.log(`[GraphQL error]: Message: ${message}`, { locations, path }));
    handleAuthError(graphQLErrors);
  }
  if (networkError) console.log(`[Network error]: ${networkError}`);
});

// Session → JWT migration: attach the Bearer token per operation so a renewed
// token is picked up without recreating the client. An expired token is never
// sent — the server rejects a bad Bearer token with no session fallback.
const authLink = setContext((_, { headers }) => {
  const token = getAccessToken();
  if (!token || isTokenExpired(token)) return { headers };
  return { headers: { ...headers, authorization: `Bearer ${token}` } };
});

export const serverStackClientV2 = new ApolloClient({
  link: ApolloLink.from([
    errorLink,
    authLink,
    createUploadLink({
      uri: config?.server_stack_url,
      credentials: "include",
      headers: {
        "apollo-require-preflight": "true"
      }
    })
  ]),
  cache: new InMemoryCache()
});
